/* globals PORTAL_DIRECTORY */
import { reactTransactionsTable } from "./tables/transactions/reactTransactionsTable.directive";
import { reactStatementsTable } from "./tables/statements/reactStatementsTable.directive";
import {
    reactStatementTransactionsTable
} from "./tables/statementTransactions/reactStatementTransactionsTable.directive";
import { reactIntradaysTable } from "./tables/intradays/reactIntradaysTable.directive";
import { reactIntradayEntriesTable } from "./tables/intradayEntries/reactIntradayEntriesTable.directive";
import { reactUserReportsTable } from "./tables/administration/userReports/reactUserReportsTable.directive";
import { reactAccountsTable } from "./tables/accounts/reactAccountsTable.directive";
import { reactEditAccountsTable } from "./tables/accounts/reactEditAccountsTable.directive";
import { reactValueSeriesTable } from "./tables/valueseries/reactValueSeriesTable.directive";
import { reactStatementsMainTable } from "./tables/statements/reactStatementsMainTable.directive";
import { reactIntradaysMainTable } from "./tables/intradays/reactIntradayMainTable.directive";
import {
    reactAdministrationAccountsTable
} from "./tables/administration/accounts/reactAdministrationAccountsTable.directive";
import {
    reactAdministrationGroupsTable
} from "./tables/administration/groups/reactAdministrationGroupsTable.directive";
import { reactReportingAccountsTable } from "./tables/administration/reporting/reactReportingAccountsTable.directive";
import { react2angular } from 'react2angular';
import { AwApplicationHeader } from "./react/AwApplicationHeader";
import { AwDataGrid } from './react/AwDataGrid';
import { AwThemedTabs } from "./react/AwThemedTabs";
import { AwThemedPageTitle } from "./react/AwThemedPageTitle";

export class ReactComponents {
    /** @ngInject */
    constructor(arswebModule) {
        this.arswebModule = arswebModule;
    }

    defineComponents() {
        this.arswebModule
          .directive('reactTransactionsTable', reactTransactionsTable)
          .directive('reactStatementsTable', reactStatementsTable)
          .directive('reactStatementTransactionsTable', reactStatementTransactionsTable)
          .directive('reactIntradaysTable', reactIntradaysTable)
          .directive('reactIntradayEntriesTable', reactIntradayEntriesTable)
          .directive('reactUserReportsTable', reactUserReportsTable)
          .directive('reactAccountsTable', reactAccountsTable)
          .directive('reactEditAccountsTable', reactEditAccountsTable)
          .directive('reactValueSeriesTable', reactValueSeriesTable)
          .directive("reactStatementsMainTable", reactStatementsMainTable)
          .directive("reactIntradaysMainTable", reactIntradaysMainTable)
          .directive("reactAdministrationAccountsTable", reactAdministrationAccountsTable)
          .directive("reactAdministrationGroupsTable", reactAdministrationGroupsTable)
          .directive("reactReportingAccountsTable", reactReportingAccountsTable)

          .constant('PORTAL_DIRECTORY', PORTAL_DIRECTORY)
          .component('awApplicationHeader', react2angular(AwApplicationHeader, ['vm'], ['PORTAL_DIRECTORY']))
          .component('awDataGrid', react2angular(AwDataGrid, ['id', 'props']))
          .component('awThemedTabs', react2angular(AwThemedTabs, ['id', 'props']))
          .component('awThemedPageTitle', react2angular(AwThemedPageTitle, ['id', 'props']))
        ;
    }
}
